import React, { useState, useEffect } from "react";
import { View } from "react-native";

import cardStyles from "./cardStyles";
import CloseIcon from "../../common/dialog/CloseIcon";
import Goal from "../../resolution/goals/Goal";
import CardUtils from "./CardUtils";

export default function AlmostThereCard({ controller, data, isSnoozed = false, onSnooze = null }) {
  const [showCard, setShowCard] = useState(false);

  const cardUtils = new CardUtils(controller, data, setShowCard);
  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  let message = `Make some more time for ${data.name} by the end of the ${data.interval} to hit your goal!`;
  if (data.mood > 3) {
    message = `You're right on schedule this ${data.interval}!`;
  }
  if (data.mood < 3) {
    message = `You need to make some more time for ${data.name} by the end of the ${data.interval} to hit your goal!`;
  }

  const goal = {
    target_name: data.name,
    target_emoji: data.icon,
    hours: data.tracked,
    target_hours: data.target,
    time_unit: data.goal_time_unit,
    target_achieved: 0,
    total_pct: Math.max(Math.min(Math.abs(data.total_pct), 1), 0),
    achieved_pct: data.target ? data.tracked / data.target : 0,
    mood: data.mood,
    text: message,
  };

  return !isSnoozed && !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 86 }]}>
        <CloseIcon
          onPress={(e) => onSnooze(cardUtils, e)}
          color="#2D3142"
          style={cardStyles.closeButton}
        />

        <View style={{ width: "100%" }}>
          <Goal
            style={cardStyles.goal}
            controller={controller}
            goal={goal}
            allowEdit={false}
          />
        </View>
      </View>
    </View>
  );
}
